import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useSnackbar } from "notistack";
import TextInput from "../../components/textInput";
import logo from "../../assets/icons/applogo.png";

const DeletationForm = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name || !formData.email || !formData.message) {
      enqueueSnackbar("Please fill all fields!", { variant: "error" });
      return;
    }

    setLoading(true);

    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      enqueueSnackbar("Deletion request submitted successfully!", {
        variant: "success",
      });

      // Reset form
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    }, 2000);
  };

  return (
    <Box
      height={"100vh"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
    >
      <Container
        maxWidth="md"
        my={4}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        height={"100vh"}
        flexDirection={"column"}
      >
        <Box
          bgcolor="primary.bgLight"
          padding={"20px"}
          borderRadius={"22px"}
          mt={0}
          my={"auto"}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <img
              src={logo}
              alt="logo"
              style={{ width: "120px", height: "100px" }}
            />

            <Typography
              variant="h4"
              fontWeight={600}
              mb={1}
              color="primary.main"
              textAlign={"center"}
            >
              Account Deletion Request
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              mb={3}
              textAlign={"center"}
            >
              We're sorry to see you go. Please fill out the form below to
              submit your account deletion request. Our team will process your
              request within 24-48 hours.
            </Typography>
          </Box>

          <Box component="form" onSubmit={handleSubmit}>
            <Box my={2}>
              <Typography variant="body1" color="text.secondary" mb={1}>
                Name
              </Typography>
              <TextInput
                fullWidth
                // label="Name"
                placeholder="Enter Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                margin="normal"
              />
            </Box>
            <Box my={2}>
              <Typography variant="body1" color="text.secondary" mb={1}>
                Email
              </Typography>
              <TextInput
                fullWidth
                placeholder="Enter Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                margin="normal"
              />
            </Box>

            <Box my={2}>
              <Typography variant="body1" color="text.secondary" mb={1}>
                Message
              </Typography>
              <TextInput
                fullWidth
                placeholder="Enter Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                margin="normal"
                multiline
                rows={4}
              />
            </Box>

            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                mt: 3,
                py: 1.5,
                backgroundColor: "#4CAF50",
                "&:hover": {
                  backgroundColor: "#45a049",
                },
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              {loading ? (
                <>
                  <CircularProgress size={24} sx={{ color: "#fff", mr: 1 }} />
                  Submitting...
                </>
              ) : (
                "Submit Deletion Request"
              )}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default DeletationForm;
